/* BD Interactive Columns – JS (stacked <img> fade) */
(function() {
  const MOBILE_QUERY = window.matchMedia('(max-width: 768px)');

  class BDInteractiveColumns {
    constructor(root) {
      this.root      = root;
      this.content   = root.querySelector('.bd-interactive-columns__text-content');
      this.leftCol   = root.querySelector('.bd-interactive-columns__left');
      this.rightCol  = root.querySelector('.bd-interactive-columns__right');
      this.container = root.querySelector('.bd-interactive-columns__container');
      this.bgStack   = root.querySelector('.bd-interactive-columns__bg-stack');
      this.items     = Array.from(root.querySelectorAll('.bd-interactive-columns__item'));

      this.bgCache    = new Map();
      this.visibleImg = null;
      this.isMobile   = MOBILE_QUERY.matches;
      this.currentIndex = -1;

      this.bind();

      // initiale afbeelding
      const initial = this.rightCol?.getAttribute('data-initial-image');
      if (initial) this.showStackedImage(initial);

      if (this.items.length) this.activate(0, false);
    }

    bind() {
      this.items.forEach((item, index) => {
        item.addEventListener('click', () => this.activate(index, true));
        item.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.activate(index, true); }
        });
        item.addEventListener('mouseenter', () => {
          if (!this.isMobile) this.activate(index, true);
        });
      });
      MOBILE_QUERY.addEventListener?.('change', (e) => this.isMobile = e.matches);
    }

    activate(index, animate = true) {
      if (index === this.currentIndex) return;
      this.currentIndex = index;

      this.items.forEach((el, i) => el.setAttribute('aria-pressed', i === index ? 'true' : 'false'));
      const item = this.items[index];
      const tpl  = this.root.querySelector(`#${item.dataset.contentId}`);
      if (!tpl) return;

      if (animate) this.fadeOutIn(this.content, () => this.content.innerHTML = tpl.innerHTML);
      else this.content.innerHTML = tpl.innerHTML;

      const bgColor = tpl.dataset.backgroundColor;
      this.leftCol.style.backgroundColor = bgColor || '';
      const mobileBg = tpl.dataset.mobileBgColor;
      if (mobileBg) this.root.style.setProperty('--mobile-bg-color', mobileBg);

      if(this.container){
      this.container.style.setProperty('--bg-color', bgColor);
     }

      this.showStackedImage(tpl.dataset.backgroundImage);
    }

    getOrCreateImg(url) {
      if (!this.bgStack || !url || url === 'none') return null;
      let img = this.bgCache.get(url);
      if (img) return img;
      img = document.createElement('img');
      img.alt = '';
      img.decoding = 'async';
      img.loading = 'eager';
      img.fetchPriority = 'auto';
      img.src = url;
      this.bgStack.appendChild(img);
      this.bgCache.set(url, img);
      return img;
    }

    async showStackedImage(url) {
      if (!url || url === 'none') {
        if (this.visibleImg) this.visibleImg.classList.remove('is-visible');
        this.visibleImg = null;
        return;
      }
      const nextImg = this.getOrCreateImg(url);
      if (!nextImg) return;
      try { await nextImg.decode?.(); } catch(e) {}
      nextImg.classList.add('is-visible');
      if (this.visibleImg && this.visibleImg !== nextImg) this.visibleImg.classList.remove('is-visible');
      this.visibleImg = nextImg;
    }

    fadeOutIn(node, onMid) {
      node.classList.add('bd-fade-out');
      window.setTimeout(() => {
        onMid?.();
        node.classList.remove('bd-fade-out');
        node.classList.add('bd-fade-in');
        window.setTimeout(() => node.classList.remove('bd-fade-in'), 220);
      }, 180);
    }
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-behavior="bd-interactive-columns"]').forEach((root) => {
      if (!root.__bdInteractiveColumns) {
        root.__bdInteractiveColumns = new BDInteractiveColumns(root);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
